import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthStateService {
    private _isAuthCheckComplete = new BehaviorSubject<boolean>(false);
    private _isAuthorizationInProgress = new BehaviorSubject<boolean>(false);

    get isAuthCheckComplete$() {
        return this._isAuthCheckComplete.asObservable();
    }

    get isAuthCheckComplete() {
        return this._isAuthCheckComplete.value;
    }

    get isAuthorizationInProgress$() {
        return this._isAuthorizationInProgress.asObservable();
    }

    get isAuthorizationInProgress() {
        return this._isAuthorizationInProgress.value;
    }

    setAuthCheckComplete(isComplete: boolean) {
        this._isAuthCheckComplete.next(isComplete);
    }

    setAuthorizationInProgress(inProgress: boolean) {
        this._isAuthorizationInProgress.next(inProgress);
    }
}
